import type { CustomTag } from 'app/typings/customTags';

export const doesCustomTagExist = (
  tags: CustomTag[] | undefined,
  name: string,
  excludedId?: number
): boolean => {
  if (!tags || !name) {
    return false;
  }

  const cleanName = cleanCustomTagString(name);

  return tags.some(
    (tag) =>
      tag.id !== excludedId && cleanCustomTagString(tag.name) === cleanName
  );
};

export const cleanCustomTagString = (str: string) =>
  str
    // remove diacritics
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
